<div class="flex min-w-0 flex-auto flex-col p-2" cdkScrollable>
    <div class="justify-start">
        {{errorMessage}}
    </div>
</div>